import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const CountryCodeSelect = ({ value, onChange, countryCodes, className = '', testId = 'country-select' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selected = countryCodes.find(c => c.code === value) || countryCodes[0];

  return (
    <div className={`relative ${className}`} ref={ref} data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 bg-transparent border-b-2 border-[#D5D1C8] focus:border-[#1A3628] outline-none py-3 text-sm font-body w-full cursor-pointer transition-colors"
      >
        <span>{selected.flag}</span>
        <span className="text-[#111C16]">{selected.code}</span>
        <ChevronDown className={`h-3 w-3 text-[#4A5D53] ml-auto transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute top-full left-0 mt-1 w-56 bg-white border border-[#D5D1C8] rounded-xl shadow-xl z-50 max-h-52 overflow-y-auto">
          {countryCodes.map((c, i) => (
            <button
              key={i}
              type="button"
              onClick={() => { onChange(c.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm font-body text-left hover:bg-[#F9F8F6] transition-colors ${c.code === value && c.country === selected.country ? 'bg-[#EAE7DF] text-[#1A3628] font-medium' : 'text-[#4A5D53]'}`}
            >
              <span>{c.flag}</span>
              <span>{c.code}</span>
              <span className="text-xs text-[#4A5D53]/60">{c.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryCodeSelect;
